import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLms } from '../../context/LmsContext';
import { Card, FormRow, PageHeader } from '../../components/ui';

export default function NewCourse() {
  const { data, currentUser, createCourse } = useLms();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    title: '',
    description: '',
    category: data.categories[0],
    targetAudience: '',
    difficulty: 'beginner',
    estimatedMinutes: 60,
    certificateEnabled: true,
    tags: ''
  });
  const [message, setMessage] = useState('');

  const submit = (event) => {
    event.preventDefault();
    const result = createCourse(form, currentUser.id);
    if (!result.ok) setMessage(result.message);
    else navigate(`/trainer/courses/${result.course.id}/builder`);
  };

  return (
    <>
      <PageHeader title="Create new course" description="New courses start as Draft and are invisible to learners until published by Admin." />
      <Card>
        <form className="form-stack" onSubmit={submit}>
          <FormRow label="Course title"><input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} /></FormRow>
          <FormRow label="Description"><textarea required rows="4" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} /></FormRow>
          <div className="form-grid">
            <FormRow label="Category"><select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}>{data.categories.map((category) => <option key={category}>{category}</option>)}</select></FormRow>
            <FormRow label="Difficulty"><select value={form.difficulty} onChange={(e) => setForm({ ...form, difficulty: e.target.value })}><option>beginner</option><option>intermediate</option><option>advanced</option></select></FormRow>
          </div>
          <div className="form-grid">
            <FormRow label="Estimated minutes"><input type="number" min="1" value={form.estimatedMinutes} onChange={(e) => setForm({ ...form, estimatedMinutes: e.target.value })} /></FormRow>
            <FormRow label="Target audience"><input required value={form.targetAudience} onChange={(e) => setForm({ ...form, targetAudience: e.target.value })} /></FormRow>
          </div>
          <FormRow label="Tags"><input placeholder="PE, design, permitting" value={form.tags} onChange={(e) => setForm({ ...form, tags: e.target.value })} /></FormRow>
          <label className="check-row"><input type="checkbox" checked={form.certificateEnabled} onChange={(e) => setForm({ ...form, certificateEnabled: e.target.checked })} /> Enable certificate after completion</label>
          <button className="button button-primary" type="submit">Create draft course</button>
          {message && <p className="form-error">{message}</p>}
        </form>
      </Card>
    </>
  );
}
